export default __webpack_public_path__ + "static/media/i-scan.33c5a39e.svg";